// Rôles et permissions du système
export const ROLES = {
  admin: {
    label: 'Administrateur',
    color: 'bg-red-600',
    bgLight: 'bg-red-100',
    textColor: 'text-red-700',
    permissions: [
      'view_all',
      'edit_all',
      'delete_all',
      'export_all',
      'manage_users',
      'approve_users',
      'manage_committee',
      'edit_finances',
      'delete_finances'
    ]
  },
  president: {
    label: 'Président',
    color: 'bg-purple-600',
    bgLight: 'bg-purple-100',
    textColor: 'text-purple-700',
    permissions: [
      'view_all',         // Accès à tous les modules en lecture
      'edit_all',         // Éditer presque tout
      'export_all',       // Exporter tous les rapports
      'view_programmes',  // Voir les programmes
      'view_fihirana',    // Voir les fihirana
      'view_finances',    // Voir les finances
      'view_members',     // Voir les membres
      'manage_programmes', // Gérer les programmes
      'manage_fihirana'   // Gérer les fihirana
    ]
  },
  pasteur: {
    label: 'Pasteur',
    color: 'bg-indigo-600',
    bgLight: 'bg-indigo-100',
    textColor: 'text-indigo-700',
    permissions: [
      'view_all',         // Accès à tous les modules en lecture
      'edit_all',         // Éditer presque tout
      'export_all',       // Exporter tous les rapports
      'view_programmes',  // Voir les programmes
      'view_fihirana',    // Voir les fihirana
      'view_finances',    // Voir les finances
      'view_members',     // Voir les membres
      'edit_members',     // Éditer les membres
      'manage_programmes', // Gérer les programmes
      'manage_fihirana',  // Gérer les fihirana
      'manage_events',    // Gérer les événements
      'view_birthdays',   // Voir les anniversaires
      'edit_programmes'   // Éditer les programmes
    ]
  },
  tresorier: {
    label: 'Trésorier',
    color: 'bg-blue-600',
    bgLight: 'bg-blue-100',
    textColor: 'text-blue-700',
    permissions: [
      'view_all',         // Accès à tous les modules en lecture
      'view_programmes',  // Voir les programmes
      'view_fihirana',    // Voir les fihirana
      'view_finances',    // Voir les finances
      'view_members',     // Voir les membres
      'edit_finances',    // Éditer les finances
      'delete_finances',  // Supprimer des finances
      'export_finances',  // Exporter les finances
      'export_all',       // Exporter tous les rapports
      'add_donations',    // Ajouter des dons
      'add_expenses'      // Ajouter des dépenses
    ]
  },
  secretaire: {
    label: 'Secrétaire',
    color: 'bg-green-600',
    bgLight: 'bg-green-100',
    textColor: 'text-green-700',
    permissions: [
      'view_all',         // Accès à tous les modules en lecture
      'view_programmes',  // Voir les programmes
      'view_fihirana',    // Voir les fihirana
      'view_finances',    // Voir les finances
      'view_members',     // Voir les membres
      'edit_members',     // Éditer les membres
      'manage_programmes', // Gérer les programmes
      'manage_fihirana',  // Gérer les fihirana
      'export_all'        // Exporter les rapports
    ]
  },
  membre: {
    label: 'Membre',
    color: 'bg-gray-600',
    bgLight: 'bg-gray-100',
    textColor: 'text-gray-700',
    permissions: [
      'view_own_contributions', // Voir ses propres contributions
      'view_programmes',        // Voir les programmes
      'view_fihirana'          // Voir les fihirana
      // Note: Les membres n'ont PAS accès à :
      // - view_finances (finances globales)
      // - view_members (liste complète)
      // - edit/delete/manage (modifications)
    ]
  },
  pending: {
    label: 'En attente',
    color: 'bg-yellow-600',
    bgLight: 'bg-yellow-100',
    textColor: 'text-yellow-700',
    permissions: []
  }
};

// Types de revenus
export const REVENUE_TYPES = [
  'Rakitra',
  'Raki-pisaorana',
  'Rakitry ny mpandray',
  'Tonona',
  'Don',
  'Événement',
  'Projet spécial',
  'Autre'
];

// Catégories de dépenses
export const EXPENSE_CATEGORIES = [
  'Loyer',
  'Zavatsoa',
  'Honoraire Pasteur',
  'Famangiana',
  'Don',
  'Autre'
];

// Méthodes de paiement
export const PAYMENT_METHODS = [
  'Espèces',
  'Virement',
  'Carte',
  'Chèque',
  'PayPal'
];

// Types de programmes
export const PROGRAMME_TYPES = [
  'Culte',
  'Réunion de Prière',
  'Étude Biblique',
  'Événement Spécial',
  'Réunion de Comité',
  'Autre'
];

// Types d'éléments de programme
export const PROGRAMME_ITEM_TYPES = {
  lohahevitra: { label: 'Lohahevitra', icon: 'Book', color: 'bg-blue-100 text-blue-700' },
  fiarahabana: { label: 'Fiarahabana apostolika', icon: 'Users', color: 'bg-purple-100 text-purple-700' },
  salamo: { label: 'Salamo', icon: 'BookOpen', color: 'bg-green-100 text-green-700' },
  vavaka: { label: 'Vavaka', icon: 'Heart', color: 'bg-pink-100 text-pink-700' },
  fankalazana: { label: 'Fankalazana ny tenin\'Andriamanitra', icon: 'Book', color: 'bg-indigo-100 text-indigo-700' },
  dimy_minitra: { label: 'Dimy minitra ho an\'ny tanora sy ny ankizy', icon: 'Users', color: 'bg-yellow-100 text-yellow-700' },
  fampianarana: { label: 'Fampianarana', icon: 'BookOpen', color: 'bg-teal-100 text-teal-700' },
  toriteny: { label: 'Toriteny', icon: 'MessageSquare', color: 'bg-orange-100 text-orange-700' },
  hira_stk: { label: 'Hira STK', icon: 'Music', color: 'bg-blue-100 text-blue-700' },
  famelan_keloka: { label: 'Famelan-keloka', icon: 'Heart', color: 'bg-red-100 text-red-700' },
  fanekem_pinoana: { label: 'Fanekem-pinoana', icon: 'CheckSquare', color: 'bg-green-100 text-green-700' },
  filazan_draharaha: { label: 'Filazan-draharaha', icon: 'Bell', color: 'bg-gray-100 text-gray-700' },
  asa_vavolombelona: { label: 'Asa vavolombelona', icon: 'Users', color: 'bg-purple-100 text-purple-700' },
  rakitra: { label: 'Rakitra', icon: 'DollarSign', color: 'bg-green-100 text-green-700' },
  fanolorana_rakitra: { label: 'Fanolorana ny Rakitra', icon: 'DollarSign', color: 'bg-yellow-100 text-yellow-700' },
  vavaka_fangatahana: { label: 'Vavaka fangatahana', icon: 'Heart', color: 'bg-pink-100 text-pink-700' },
  fanasan_tompo: { label: 'Fanasan\'ny Tompo', icon: 'Wine', color: 'bg-purple-100 text-purple-700' },
  tsodrano: { label: 'Tsodrano', icon: 'Droplet', color: 'bg-blue-100 text-blue-700' },
  trinite: { label: 'Trinite', icon: 'Heart', color: 'bg-red-100 text-red-700' }
};

// Catégories de Fihirana
export const FIHIRANA_CATEGORIES = [
  '03 – Ny Fanahy Masina',
  '04 – Ny telo izay iray',
  '05 – Ny soratra masina, tenin\'Andriamanitra',
  '07 – Ny Fiainanana Kristiana',
  '09 – Ny fivorian\'ny tanora',
  '1.01 – Ny fiderana sy fisaorana azy',
  '1.02 – Ny asany amin\'ny famoronana',
  '1.03 – Ny Fahatsarany amin\'ny fitondrana',
  '1.04 – Ny fahasoavany amin\'ny fanavotana',
  '10 – Ny hiran\'ny ankizy',
  '11 – Litania',
  '12 – Tsanta',
  '13 – Antema',
  '2.01 – Ny fihaviany sy ny fiverenany',
  '2.02 – Ny fahaterahany',
  '2.03 – Ny fiainany',
  '2.04 – Ny fijaliany – ny fahafatesany',
  '2.05 – Ny fitsanganany',
  '2.06 – Ny fiakarany',
  '2.07 – Ny fifonany ho antsika',
  '2.08 – Ny fanatrehany',
  '2.09 – Ny fiderana sy fisaorana azy',
  '6.01 – Fanombohana sy fiantsoana',
  '6.02 – Ny Sakramentan\'ny batisa',
  '6.03 – Ny Sakramentan\'ny Fanasan\'ny Tompo',
  '6.04 – Ny firaisan\'ny mino sy ny fiarahany mivavaka',
  '6.05 – Fanateram-bokatra',
  '6.06 – Fanokanana mpitandrina, pastora, mpiasa-piangonana',
  '6.07 – Fandraisana ho mpandray',
  '6.08 – Fampielezana ny filazantsara',
  '6.09 – Fitokanana trano fiangonana',
  '6.10 – Fisaorana an\'Andriamanitra noho ny mpiasany',
  '6.11 – Firavana',
  '7.01 – Ny Antson\'ny filazantsara',
  '7.02 – Ny fibebahana',
  '7.03 – Ny famelan-keloka – ny famonjena',
  '7.04 – Ny fanolorantena – ny fankatoavana- ny fanamasinana',
  '7.05 – Ny fiovam-po – ny fiainam-baovao',
  '7.06 – Ny fiainana ao amin\'ny Kristy',
  '7.07 – Fanantenana',
  '7.08 – Finoana',
  '7.09 – Fitiavana',
  '7.10 – Fiadanana sy fifaliana',
  '7.11 – Zava-tsarotra mahazo ny kristiana sy fampaherezana',
  '7.12 – Fitarainana amin\'ny Mpamonjy',
  '7.13 – Fangataham-pitahiana sy fiarovana',
  '7.14 – Fanomanana sy fampieritreretana',
  '7.15 – Ady masina sy fandresena',
  '7.16 – Fahafatesana – fitsanganana amin\'ny maty',
  '7.17 – Ny lanitra sy ny fiainana mandrakizay',
  '8.01 – Fampakaram-bady',
  '8.02 – Fanokanana trano',
  '8.03 – Amin\'ny maraina',
  '8.04 – Amin\'ny hariva',
  '8.05 – Amin\'ny sakafo',
  '8.06 – Ny handeha lavitra',
  '8.07 – Fivavahana ho an\'ny tanindranaza',
  '8.08 – Amin\'ny faran\'ny taona',
  '8.09 – Amin\'ny taom-baovao',
  'Fihirana Fanampiny',
  'Non classé'
];

// Informations de l'église
export const CHURCH_INFO = {
  name: 'VOMM FJKM Hannover',
  fullName: {
    vomm: 'Vondron\'Olona Mpiara Mivavaka',
    fjkm: 'Fiangonan\'i Jesoa Kristy eto Madagasikara'
  },
  city: 'Hannover',
  country: 'Deutschland',
  hasPhysicalAddress: false,
  committee: {
    structure: [
      'Président',
      'Trésorier',
      'Secrétaire 1',
      'Secrétaire 2'
    ]
  }
};

// Villes d'origine (Madagascar)
export const MADAGASCAR_CITIES = [
  'Antananarivo',
  'Toamasina',
  'Antsirabe',
  'Mahajanga',
  'Fianarantsoa',
  'Toliara',
  'Antsiranana',
  'Ambatondrazaka',
  'Morondava',
  'Manakara',
  'Nosy-Be',
  'Sambava',
  'Ambanja',
  'Maroantsetra',
  'Farafangana',
  'Mananjary',
  'Ihosy',
  'Ambositra',
  'Moramanga',
  'Autre'
];

// Types de fonction pour les membres
export const FONCTION_TYPES = [
  'Fachkraft',
  'Azubi',
  'FSJ/BFD',
  'Aupair',
  'Autre'
];

// Statuts des membres
export const MEMBER_STATUS = [
  'Actif',
  'Inactif',
  'Ancien'
];

export default {
  ROLES,
  REVENUE_TYPES,
  EXPENSE_CATEGORIES,
  PAYMENT_METHODS,
  PROGRAMME_TYPES,
  PROGRAMME_ITEM_TYPES,
  FIHIRANA_CATEGORIES,
  CHURCH_INFO,
  MADAGASCAR_CITIES,
  FONCTION_TYPES,
  MEMBER_STATUS
};
